import { createApp } from 'vue';
import Cr2ToPngConverter from '../Components/Cr2ToPngConverter.vue';

const root = document.getElementById('cr2-to-png-converter');
if (root) {
  createApp(Cr2ToPngConverter).mount('#cr2-to-png-converter');
}
